import { secondAxios } from "../../../../../../api/axios";

export const createMrq = async ({ createdMrq }) => {
  const { data } = await secondAxios.post("/mrq", createdMrq);

  console.log(data);
  return data;
};
